module.exports = __webpack_public_path__ + "img/inktober_2020_08_teeth.a3ff21c8.jpg";